/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


document.addEventListener('DOMContentLoaded', () => {

  // Splide
  const splides = document.querySelectorAll('.lsbfsg-testimonials-video-slider');

  if (!!splides && splides.length > 0) {
    splides.forEach(splide => {
      const slides_count = splide.querySelectorAll('.splide__slide');

      // Grab the slide interval and convert it to an integer and milliseconds or fallback to 3000ms
      const interval = parseInt(splide.dataset.interval) * 1000 || 3000;
      const isAutoplay = splide.dataset.autoplay === "true";
      const isPauseOnHover = splide.dataset.pauseonhover === "true";
      const imagesPerSlideMob = parseInt(splide.dataset.imagesperslidemob);
      const imagesPerSlideTab = parseInt(splide.dataset.imagesperslidetab);
      const imagesPerSlideDesk = parseInt(splide.dataset.imagesperslidedesk);
      const showControls = parseInt(splide.dataset.showcontrols);
      const videoMuted = splide.dataset.videomuted === "true";
      splide.setAttribute('role', 'region');
      splide.setAttribute('aria-roledescription', 'carousel');
      splide.setAttribute('aria-label', 'Testimonial video slider');
      const breakpoints = {
        // Mobile View (up to 640px)
        640: {
          perPage: imagesPerSlideMob,  // Show only one slide on screens below 640px
        },
        // Tablet View (between 640px and 1024px)
        1024: {
          perPage: imagesPerSlideTab,  // Show two slides on screens between 640px and 1024px
        },
        // Desktop View (above 1024px)
        2560: {  // "inf" represents infinity, targeting screens larger than 1024px
          perPage: imagesPerSlideDesk,  // Show three slides on desktops
        }
      };

      new Splide(splide, {

        type: slides_count.length > (imagesPerSlideDesk - 1) ? 'loop' : 'slide', gap: "1.25rem", autoplay: isAutoplay, perMove: 1, pauseOnHover: isPauseOnHover, interval: interval, breakpoints,
        video: {
          loop: true,
          playerOptions: {
            youtube: {
              mute: videoMuted,
              controls: showControls,
            }
          },
        },
      }).mount(window.splide.Extensions);
      splide.querySelectorAll('.splide__list[role="presentation"]').forEach(list => {
        list.removeAttribute('role');
      });

      splide.querySelectorAll('.splide__slide--clone').forEach(slide => {
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('tabindex', '-1');
      });

      const prev = splide.querySelector('.splide__arrow--prev');
      if (prev) {
        prev.setAttribute('aria-label', 'Previous testimonial');
      }

      const next = splide.querySelector('.splide__arrow--next');
      if (next) {
        next.setAttribute('aria-label', 'Next testimonial');
      }
      const slides = splide.querySelectorAll('.splide__slide');

      slides.forEach((slide, index) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', `${index + 1} of ${slides.length}`);
      });
      const arrows = splide.querySelector('.splide__arrows');
      if (arrows) {
        arrows.setAttribute('role', 'group');
        arrows.setAttribute('aria-label', 'Video testimonial slider arrows');
      }

    })
  }
});

